const t=(t,a,h)=>Math.max(t,Math.min(a,h));export{t as capValue};
//# sourceMappingURL=capValue.min.mjs.map
